import { useEffect, useState } from 'react';

import { texts } from '@/lib/texts';

/**
 * Указатель «ниже есть ещё»: круглая стрелка над нижней панелью.
 *
 * На длинных экранах онбординга следующий вопрос уходит за край, и человек видит только серую
 * кнопку «Дальше» — выглядит как «форма не работает», хотя ниже просто есть незаполненный пункт.
 * Кнопка прокручивает на экран вперёд и исчезает, когда прокручивать больше нечего.
 */
export function ScrollHint() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      const doc = document.documentElement;
      const left = doc.scrollHeight - doc.clientHeight - window.scrollY;
      setVisible(left > 24);
    };
    check();
    window.addEventListener('scroll', check, { passive: true });
    const observer = new ResizeObserver(check);
    observer.observe(document.body);
    return () => {
      window.removeEventListener('scroll', check);
      observer.disconnect();
    };
  }, []);

  if (!visible) return null;
  return (
    <button
      type="button"
      aria-label={texts.common.scrollDown}
      onClick={() =>
        window.scrollBy({ top: window.innerHeight * 0.7, behavior: 'smooth' })
      }
      className="pressable bg-surface-2 text-fg border-border fixed right-4 z-30 flex h-11 w-11 items-center justify-center rounded-full border shadow-lg"
      style={{ bottom: 'calc(var(--safe-bottom) + 6.5rem)' }}
    >
      <svg width="20" height="20" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M3 6l5 5 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </button>
  );
}
